// Bootstrap for the Special Order widget. The bundle's IIFE wrapper
// runs this file on script load, which finds the mount element
// (#imobile-special-order by convention) and renders the Vue app
// inside a Shadow DOM.
//
// Embedders just need:
//   <div id="imobile-special-order"></div>
//   <script src=".../special-order/v1.js" defer></script>
//
// Optional data-* overrides on the mount element:
//   data-api-base="https://..."   replace the backend URL baked at build
//   data-on-success="handleOrder"  call window.handleOrder(result) on success
//   data-no-shadow="true"          opt out of Shadow DOM isolation

import { mountWidget } from '@shared/mount.js'
import App from './App.vue'
// ?inline asks Vite to give us the CSS as a literal string at build
// time — we then inject it into the shadow root in mountWidget so it
// applies to the widget's tree only.
import styles from './styles.css?inline'

mountWidget({
    widgetName: 'special-order',
    component: App,
    styles,
})
